import {Component, Input} from '@angular/core';
import {Nutzer} from '../../models/nutzer.model';
import {MieterDaten} from '../../models/mieter-daten.model';

@Component({
  selector: 'mp-address-header',
  templateUrl: './address-header.component.html',
  styleUrls: ['./address-header.component.css']
})
export class AddressHeaderComponent {

  @Input() data: MieterDaten;

}
